<template>
  <div>
    <!-- <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('profile') }}
    </h1> -->
    <div class="profileImg">
          <div class="userAccount">
          <div class="userAccount__image">
              <img class="user_img" src="../../assets/gameonz/imgs/dummy_account.jpg"/>
          
          </div>
          <div class="userAccount__name">
              <h1 class="mobiTitle md">{{$t("hello")}}, Alan Smith!</h1>
          </div>
        
          </div>

    </div>
    <div class="main_wrap">
        <div class="mobiSection">
            <div class="mobiSection__content">
                <div class="userProfile">
                    <div class="inputWrap">
                        <label for="" class="inputWrap__label text_color">{{ $t('full_name') }}:</label>
                        <h2 class="mobiTitle md text_color">Alan Smith</h2>
                    </div>
                    <div class="inputWrap">
                        <label for="" class="inputWrap__label text_color">{{ $t('registered_num') }}:</label>
                        <h2 class="mobiTitle md text_color">25471111111</h2>
                    </div>
                    <div class="inputWrap">
                        <label for="" class="inputWrap__label text_color">{{ $t('registered_email') }}:</label>
                        <h2 class="mobiTitle md text_color">test@test.com</h2>
                    </div>  
                     <div class="inputWrap">
                        <label for="" class="inputWrap__label text_color">{{ $t('registered_date') }}:</label>
                        <h2 class="mobiTitle md text_color">01 April 2018</h2>
                    </div> 
                      
                </div>
                <div class="btnContainer "><a @click="logout()"  href="/logout" class="mobiBtn">{{ $t("unsubscribe") }}</a></div>
            </div>
        </div>
    </div>  
    
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      // localStorage.clear();
      localStorage.removeItem("userTokenID_gonz");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }
};
</script>

<style scoped lang="scss">
.profileImg {
  margin-bottom: 3rem;
  text-align: center;
  .mobiTitle {
    color: #fff;
  }
}
.userAccount__image {
  width: 92px;
  height: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.userAccount__name {
  p {
    color: #000;
  }
  margin-top: 15px;
}
.inputWrap {
  label {
    color: #01af58;
    font-weight: 600;
  }
}
.ar_layout {
  .userAccount__name .mobiTitle {
    text-align: center;
  }
  .inputWrap {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fun2win/Profile.vue